module.exports = __webpack_public_path__ + "img/4.ID.5beda31c.jpg";